/**
 * Translates seconds into human readable format of seconds, minutes, hours, days, and years
 *
 * @param  {number} seconds The number of seconds to be processed
 * @return {string}         The phrase describing the amount of time
 */
export function durationForHumans(seconds) {
  var levels = [
    [Math.floor(seconds / 31536000), 'y'],
    [Math.floor((seconds % 31536000) / 86400), 'd'],
    [Math.floor(((seconds % 31536000) % 86400) / 3600), 'hr'],
    [Math.floor((((seconds % 31536000) % 86400) % 3600) / 60), 'm'],
    [(((seconds % 31536000) % 86400) % 3600) % 60, 's'],
  ];
  var returntext = '';

  for (var i = 0, max = levels.length; i < max; i++) {
    if (levels[i][0] === 0) continue;
    returntext += ' ' + levels[i][0] + '' + levels[i][1];
  }
  return returntext.trim();
}

/**
 * Returns basename of a filename in a full path
 * Example: /path/to/a/file.txt
 * returns file.txt
 * @param {Retru} str
 */
export function baseName(path) {
  return new String(path).split(/[\\/]/).pop();
}

/**
 * The function generates a random temporary ID.
 * @returns a random number generated using Math.random() multiplied by Number.MAX_SAFE_INTEGER.
 */
export const generateTempId = () => {
  const randomValue = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
  return randomValue;
};

/**
 * Retrieves a cookie value by its name from the document's cookies.
 *
 * @param {string} cookieName - The name of the cookie to retrieve.
 * @returns {string|null} The value of the cookie if found, or null if not found.
 */
export const getCookie = cookieName => {
  const cookiePrefix = cookieName + '=';
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    let currentCookie = cookies[i].trim();

    if (currentCookie.indexOf(cookiePrefix) === 0) {
      return currentCookie.substring(cookiePrefix.length);
    }
  }

  return null;
};

/**
 * Sets a cookie with the specified name, value, and optional expiration period.
 *
 * @param {string} name - The name of the cookie.
 * @param {string} value - The value to store in the cookie.
 * @param {number} daysToExpire - Optional. The number of days until the cookie expires.
 *                                If not provided, the cookie will expire at the end of the current day.
 */
export const setCookie = (name, value, daysToExpire) => {
  const currentDate = new Date();
  const expires = daysToExpire
    ? new Date(currentDate.getTime() + daysToExpire * 24 * 60 * 60 * 1000)
    : new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59);

  const cookieString = `${name}=${value}; expires=${expires.toGMTString()}; path=/`;
  document.cookie = cookieString;
};